import React, { useState } from 'react';
import './App.css';
import structureImg from './assets/investment-structure.png'
import processImg from './assets/investment-process.png'
import hotelImg from './assets/hotelimg.png'
import reportImg from './assets/reports.png'
import socialImg from './assets/socialImg.png'
import locationImg from './assets/locationImg.png'
import logoImg from './assets/logo.png'
import investImg from './assets/investment-development.png'
import initImg from './assets/initiative.png'
import featureImg from './assets/features.png'
import objectImg from './assets/objective.png'
import productImg from './assets/product.png'
import koreaImg from './assets/korea.png'
import localImg from './assets/Local.png'
import worldImg from './assets/world.png'
import benefitImg1 from './assets/benefit1.png'
import benefitImg2 from './assets/benefit2.png'
import profilemp from './assets/profile.mp4'
import profilework1 from './assets/profilework1.jpg'
import profilework2 from './assets/profilework2.jpg'
import visionmp from './assets/visionmp.mp4'
import vision1 from './assets/vision1.jpg'
import vision2 from './assets/vision2.jpg'
import vision3 from './assets/vision3.jpg'
import businessmp from './assets/businessmp.mp4'
import investmp from './assets/investmp.mp4'
import processmp from './assets/processmp.mp4'
import processimg1 from './assets/processimg1.jpg'
import processimg2 from './assets/processimg2.jpg'
import initiativemp from './assets/initiativemp.mp4'
import featuremp from './assets/featuremp.mp4'
import objectmp from './assets/objectmp.mp4'
import productmp from './assets/productmp.mp4'
import globalimg1 from './assets/global1.jpg'
import globalimg2 from './assets/global2.png'
import globalmp from './assets/globalmp.mp4'
import benefitimg1 from './assets/benefit1.jpg'
import benefitimg2 from './assets/benefit2.jpg'
import contactimg from './assets/contactimg.jpg'
import ceoimg from './assets/ceo.jpg'

function App() {
  const [activeTab, setActiveTab] = useState('Home');

  const renderContent = () => {
    switch (activeTab) {
      case 'Home':
        return <Home />;
      case 'Introduction':
        return <Introduction />;
      case 'Business':
        return <Business />;
      case 'Fiber Optic Cable':
        return <Fiber />;
      case 'Contact Us':
        return <ContactUs />;
      default:
        return <Home />;
    }
  };

  return (
    <div className="App">
      <header className="header">
      {/* App.js 내부의 header 부분 */}
        <div className="logo-container" onClick={() => setActiveTab('Home')} style={{ cursor: 'pointer'}}>
          <img src={logoImg} alt="Mega8 Logo" className="header-logo-img" />
          <div className="logo-text-group">
            <span className="logo-subtext">INVESTMENT & FINANCE</span>
            <h1 className="logo-text">Mega8 Holdings Company</h1>
          </div>
        </div>
        {/* 오른쪽 가로 메뉴 */}
        <nav className="nav-bar">
          {['Introduction', 'Business', 'Fiber Optic Cable', 'Contact Us'].map((tab) => (
            <button 
              key={tab} 
              className={`nav-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </nav>
      </header>

      <main className="main-content">
        {renderContent()}
      </main>
    </div>
  );}
const Home = () => (
  <div className="home-section">
    <div className="hero-banner" style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop)' }}>
      <div className="hero-overlay">
        <h2 className="animate-text title">
          Sowing healthy seeds to blossom <br></br>hope here in Bangladesh
          </h2>
        <h3 className="animate-text sub-1">Accelerating Economy</h3>
        <h3 className="animate-text sub-2">Elevating Art of Living</h3>
        <h3 className="animate-text sub-3">Shaping Dream & Future</h3>
      </div>
    </div>
  </div>
);

const Introduction = () => {
  // 소메뉴 상태 관리 (기본값: How We Invest)
  const [subTab, setSubTab] = useState('CEO\'s Message');

  const renderSubContent = () => {
    switch (subTab) {
      case 'CEO\'s Message':
        return (
          <div className="sub-content-detail" key="1">
            <h3>CEO's MESSAGE</h3>
            <br></br>

            <p>Dear Valued Clients and Partners,</p><br></br>
            
            <p>First and foremost, I would like to express my sincere gratitude for your continued trust, support, and confidence in our company. Drawing upon our extensive international experience and expertise in investment development, we are committed to creating new growth engines for Bangladesh while delivering meaningful social and economic value through a diverse range of strategic initiatives.</p><br></br>

            <p>One of our key priorities is accelerating Bangladesh’s transition into a digitally advanced society by enhancing optical fiber networks, strengthening telecommunications infrastructure, and improving nationwide connectivity and information services. In addition, we are dedicated to delivering exceptional value across a broad spectrum of industries that are vital to sustainable economic growth, including manufacturing, infrastructure and public utilities, urban development, information technology, agro-processing, fisheries, and service sectors. </p>
            <br></br>

            <p>Through close collaboration with government agencies, public institutions, private enterprises, and global investment partners, we continuously identify and implement innovative Public-Private Partnership (PPP) projects that contribute to national economic development and strengthen industrial competitiveness.</p>
            <br></br>

            <p>At the heart of everything we do are the values of trust, responsibility, and shared prosperity. Guided by these principles, we strive to be a long-term global partner in Bangladesh’s sustainable development journey and a catalyst for mutual growth and success. Looking ahead, we will continue to embrace innovation, pursue new opportunities, and create lasting value for our stakeholders while helping build a healthier, more prosperous future together.</p>
            <p>Thank you.</p>
          </div>
        );
            
      case 'Company Profile':
        return (
          <div className="sub-content-detail">
            <div className="profile-video-section">
              <h2 className="video-section-title">
                LAYING THE FOUNDATION FOR SUSTAINABLE GROWTH AND <br></br>
                SHARED PROSPERITY OF HUMAN BEING
              </h2>

              <div className="video-player-wrapper">
                <video 
                src={profilemp}
                controls
                className="profile-video"
                />
                
              </div>
            </div>



              <h3>We are developing and investing for better Human Value! </h3><br></br>
              <p>Mega8 was established to contribute to the development of economy in Bangladesh creating sustainable growth through strategic investments across domestic infrastructure, energy, healthcare, ICT, and other advanced industries, working in close partnership with BEPZA, government authorities and other relevant organizations.</p>
              <br></br>

              <h3>Legislation</h3><br></br>
              <p>Established in 2021 under the Global Investment Corporation Act, Mega8 manages assets in full compliance with relevant laws and regulations. Our organization makes decisions and takes action based on clear standards and legal grounds.</p>
              <br></br>

              <h3>Global Partnership</h3><br></br>
              <p>As Global’s sovereign wealth fund striving to be among the world’s best, Mega8 has built a broad and close-knit network with leading global financial institutions.</p>
              <p>This network serves as a key driver of Mega8’s competitiveness, enhancing access to high-quality investment information and opportunities, and strengthening its position in investment negotiations.</p>
              <br></br>

              <h3>Organization</h3><br></br>
              <p>Mega8’s organizational structure is systematically designed to support efficient asset management and responsible investment practices.</p>
              <p>Led by the CEO, key decision-making is carried out by the Executive Committee, the Board of Directors, and the Audit Office. Specialized departments—including investment, risk management, and compliance—collaborate closely to implement Mega8’s global investment strategies.</p>

              <br></br>
              <h3>Governance</h3><br></br>
              <p>Mega8 is committed to ethical and transparent management. We manage national assets in a stable manner through an honest and fair system and faithfully fulfill our social responsibilities for the future of Global.</p>
              <br></br>
              <h3>Steering Committee</h3><br></br>
              <p>Meet our Steering Committee that deliberates and decides on matters including investment policies, and management and operational policies.</p>

              <div className="profile-worker-row">
                <div className="profile-worker-wrapper">
                  <img
                  src={profilework1}
                  className="profile-work-img"
                  ></img>
                </div>
                <div className="profile-worker-wrapper">
                  <img
                  src={profilework2}
                  className="profile-work-img"
                  ></img>
                </div>

              </div>
          </div>
        );
      case 'Our Vision':
        return (
          <div className="sub-content-detail" key="3">
            <h2>OUR VISION</h2>
            <br></br>
            <div className="profile-video-section">
              <h3 className="video-section-title2">
                CREATING SUSTAINABLE ENVIRONMENT FOR HEALTHIER, MORE PROSPEROUS BANGLADESH 
              </h3>

              <div className="video-player-wrapper">
                <video 
                src={visionmp}
                controls
                className="profile-video"
                />
                
              </div>
            </div>

            <h2>OUR MISSION</h2>
            <ol className="process-list">
              <li><strong>1. Sustainable Development</strong>
              <p>To develop environmentally responsible and sustainable business environments that enhance the quality of life and future generations.</p>
              </li>

              <li><strong>2. Community & Economic Growth</strong>
                <p>To contribute to local economic growth and community development through responsible investment and job creation in Bangladesh.</p>
              </li>

              <li><strong>3. Innovation & Operational Excellence</strong>
                <p>To deliver innovative, efficient, and reliable solutions through professional management and continuous improvement.</p>
              </li>

              <li><strong>4. Trust & Long-Term Partnership</strong>
                <p>To build trusted long-term partnerships with governments, communities, clients, and stakeholders based on integrity and mutual growth.</p>
              </li>
            </ol>
              <div className="profile-vision-row">
                <div className="profile-vision-wrapper">
                  <img
                  src={vision1}
                  className="profile-vision-img"
                  ></img>
                </div>
                <div className="profile-vision-wrapper">
                  <img
                  src={vision2}
                  className="profile-vision-img"
                  ></img>
                </div>
                <div className="profile-vision-wrapper">
                  <img
                  src={vision3}
                  className="profile-vision-img"
                  ></img>
                </div>

              </div>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['CEO\'s Message', 'Company Profile', 'Our Vision'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}

      {subTab == "CEO\'s Message" && (
        <div classname="side-nav-img-box">
          <img src={ceoimg} alt="CEO" className="side-nav-target-img"></img>
          <p className="center">MR. JAENAM KOH
          <br></br>Chairman</p>
        </div>
      )}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const Business = () => {
  // 소메뉴 상태 관리 (기본값: Press Release)
  const [subTab, setSubTab] = useState('Business Area');
  const [Announcements, setAnnouncement] = useState('Now Announcement');

  const renderSubContent = () => {
    switch (subTab) {
      case 'Business Area':
        return (
          <div className="sub-content-detail" key="Business">
              <div className="profile-video-section">
              <h2 className="video-section-title3">
                BUSINESS SCOPE
              </h2>
                <div className="video-player-wrapper">
                  <video 
                  src={businessmp}
                  controls
                  className="profile-video"
                  />
                  <div className="video-fixed-subtitle">
                    <p>
                      <span classname="sub-line">FROM ESSENTIAL INFRASTRUCTURE</span>
                      <br></br> 
                      <span classname="sub-line">TO HIGH-TECH INDUSTRIES IN BANGLADESH</span>
                      </p>
                  </div>
                  
                </div>
                <br></br><br></br>
              <h2 className="video-section-title3">
                BUSINESS AREA
              </h2>
              <p>We focus on Development of Industrial Infrastructure in Bangladesh </p>
              <br></br>
              </div>
            

          <div className="business-image-container">
            <img 
              src={processImg} 
              className="process-diagram-img" 
            />
          </div>
        </div>
        );
      case 'Investment & Development':
        return (
          <div className="sub-content-detail" key="invest">
            <h2>INVESTMENT & DEVELOPMENT</h2>
            <br></br>
            <p> Sustainable Development of Industrial Infrastructure<br></br> 
            and Improvement of Living Environments into Bangladesh </p>
            <div className="profile-video-section">
              <div className="video-player-wrapper">
                <video 
                src={investmp}
                controls
                className="profile-video"
                />
                <div className="video-fixed-subtitle2">
                    <p>
                      <span classname="sub-line">PROGRESSIVE IMPROVEMENT OF LIVING ENVIRONMENT</span>
                      <br></br> 
                      <span classname="sub-line">WITH INNOVATION & CREATION </span>
                      </p>
                  </div>
                
              </div>
            </div>

            <div className="animate-text sub1">
              <h2>Business Operation</h2> <br></br>

              <p>Generate a strong engine for growth of Bangladesh through the integration of abundant workforce and resources with advanced foreign technology and capital from abroad.</p>
              <br></br><br></br>

              <div className="animate-text invest-image-container sub3">
                <img
                  src={investImg}
                  alt="Sustainable Investment Process"
                  className="process-diagram-img"
                />
                
              </div>
            </div>
          </div>
          
        );
      case 'Process':
        return (
          <div className="sub-content-detail" key="2">
            <h2>INVESTMENT PROCESS</h2> <br></br>
            <div className="profile-video-section">
              <div className="video-player-wrapper">
                <video 
                src={processmp}
                controls
                className="profile-video"
                />
                <div className="video-fixed-subtitle3">
                    <p>
                    CREATION OF HUMANITARIAN VALUE AND WELLNESS   
                    </p>
                  </div>
                
              </div>
            </div>
            <h2 className="animate-text title">Process</h2><br></br>
            <h3 className="animate-text title">Our investment aims to generate long-term investment returns based on thorough research.</h3>
<br></br>
            <ol className="process-list">
              <li className="animate-text sub2"><strong>Step 1. Set investment goals</strong>
              <p>Set long-term investment goals to preserve and increase the value of sovereign wealth</p>
              </li>
              <li className="animate-text sub3"><strong>Step 2. Conduct macroeconomic analysis</strong>
              <p>Carry out mid- and long-term macroeconomic research</p>
              <p>Discover and analyze new asset classes</p>
              <p>Analyze capital market expectations for each asset class</p>
              </li>
              <li className="animate-text sub4"><strong>Step 3. Implement strategic asset allocation</strong>
              <p>Analyze the risk-return profile and investment constraints for each sponsor</p>
              <p> Set optimal asset allocation rules to improve long-term returns</p>
              </li>
              <li className="animate-text sub5"><strong>Step 4. Establish investment management plans</strong>
              <p>Carry out mid- and short-term financial market analysis and forecasting</p>
              <p>Establish mid-term and annual management plans based on the economic outlook and financial market forecast</p>
              </li>
              <li className="animate-text sub6"><strong>Step 5. Execute investment strategies</strong>
              <p>Execute an asset allocation strategy based on house views decided at quarterly asset allocation forum</p>
              <p> Preemptively analyze risks according to financial market circumstances and reflect the in the overall portfolio</p>
              <p> Establish and implement investment strategies within risk limits for each asset class and fund investment</p>
              </li>
              <li className="animate-text sub7"><strong>Step 6. Monitor and analyze performance</strong>
              <p>Analyze ex-post risks and performance factors for the entire portfolio and individual investments</p>
              <p>Correct setbacks and reflect improvements based on performance and process monitoring</p>
              </li>

              {/* ... 이전 코드의 리스트 내용 동일하게 유지 ... */}
            </ol>
            <div className="profile-worker-row">
                <div className="profile-worker-wrapper">
                  <img
                  src={processimg1}
                  className="profile-work-img"
                  ></img>
                </div>
                <div className="profile-worker-wrapper">
                  <img
                  src={processimg2}
                  className="profile-work-img"
                  ></img>
                </div>

              </div>
          </div>
        );
        case 'Initiatives':
          return(
            <div className="sub-content-detail">
            <h2>PIONEERING DIGITAL FUTURE OF BANGLADESH</h2> <br></br>
            <div className="profile-video-section">
              <div className="video-player-wrapper">
                <video 
                src={initiativemp}
                controls
                className="profile-video"
                />
                <div className="video-fixed-subtitle3">
                    <p>
                    <span className="sub-line">INVESTING IN PEOPLE, IMPROVING LIVES, BUILDING </span><br></br>
                    <span className="sub-line">A BETTER ENVIRONMENT FOR BANGLADESH  </span>
                    </p>
                  </div>
                
              </div>
            </div>
              <div className="sub-content-body">
                <h3>Our program is a Strategic Industrial Development Initiative </h3>
                <p>designed to simultaneously strengthen digital industrial infrastructure, food security, and manufacturing capability in Bangladesh. </p>
                <br></br>

                <h3>The program integrates : </h3>
                <br></br>
                
                <ul classname="initiatives-list">
                  <li className="list-container">
                    <strong className="item-title">• Fiber Optic Cable Manufacturing Industry</strong>
                    <p className="item-content">- Import substitution of telecom materials </p>
                    <p className="item-content">- Strengthened national digital infrastructure capacity</p>
                  </li><br></br>

                  <li className="list-container">
                    <strong className="item-title">• Electric Bus Assembly Plant in types of SKD or CKD </strong>
                    <p className="item-content">- Establishing a clean and secure public transportation environment </p>
                    <p className="item-content">- Modernizing urban mobility and boosting the city’s brand identit</p>
                  </li><br></br>

                  <li className="list-container">
                    <strong className="item-title">• Duck Farming, Processing, and Corn Feed Industry </strong>
                    <p className="item-content">- Stabilization of national protein supply and food prices </p>
                    <p className="item-content">- Large-scale rural employment and income generation</p>
                  </li><br></br>

                  <li className="list-container">
                    <strong className="item-title">• High-tech Hospital with advanced system and equipment </strong>
                    <p className="item-content">- Enhancement of public health welfare and medical care </p>
                    <p className="item-content">- Advancing medical technology and services to global standards</p>
                  </li><br></br>
                </ul>
                <p>Through localized production, employment creation, and technology transfer, the program will contribute  meaningfully to national industrial capability. </p>

              </div>
              <div className="init-img-wrapper">
                <img
                src={initImg}
                className="init-img-container"
                ></img>
                </div>
            </div>
        );
      default:
        return null;
    }
  };

  return (
    // Investment에서 썼던 클래스명 'horizontal-layout'을 그대로 사용합니다.
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['Business Area', 'Investment & Development', 'Process', 'Initiatives'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const Fiber = () => {
  // 소메뉴 상태 관리
  const [subTab, setSubTab] = useState('Features');
  const [productSubTab, setProductSubTab] = useState('Fiber Optic');
  const [marketSubTab, setMarketSubTab] = useState('Global Market');


  const renderSubContent = () => {
    switch (subTab) {
      case 'Features':
        return (
          <div className="sub-content-detail">
            <h2>Pioneering the Digital Future of Bangladesh</h2>
            <br></br>
            <p>• Distribution and sales of High-quality Fiber Optical Cables from Korea</p>
            <p>• Construction of the local manufacturing plants is in progress in Bangladesh(to be opened in 2027)</p>
              <div className="video-player-wrapper">
                <video 
                src={featuremp}
                controls
                className="profile-video"
                />
                <div className="video-fixed-subtitle3">
                    <p>
                    <span className="sub-line">Elevating Bangladesh’s digital and industrial</span><br></br>
                    <span className="sub-line">infrastructure to the next another level  </span>
                    </p>
                </div>

            </div><br></br><br></br>
            <h2>PRODUCTION FACILITIES</h2> <br></br>
            <p>• Strategic Production Hub for Advanced Korean Optical Technology at Jashore EPZ</p>
            <p>• To elevate Bangladesh’s digital and industrial infrastructure to the next another level</p>

            <div className="animate-text feature-image-container sub1">
                <img
                  src={featureImg}
                  alt="Sustainable Investment Process"
                />
              <p className="feature-text">Target Completion in 2028</p>
            </div>
          </div>
        );
      case 'Objectives':
        return (
          <div className="sub-content-detail">

            <h2>DIGITALIZED BANGLADESH</h2>
            <h3>Faster shift toward IT & AI Society </h3>
            <div className="video-player-wrapper">
                <video 
                src={objectmp}
                controls
                autoPlay
                muted
                className="profile-video"
                />
            </div><br></br><br></br>

            <h2>Accelerating the shift toward Digitalized and Advanced Bangladesh </h2>
            <br></br>

            <div className="object-image-container">
              <h3 className="object-text">Background and Objectives</h3><br></br>
              <div className="object-img-wrapper">
                <img src={objectImg}/>
              </div>
            </div>

            <strong>•Accelerating Bangladesh's Digital Transformation:</strong>
            <p>While Bangladesh is pursuing the "Smart Bangladesh" vision, the current digital infrastructure remains relatively underdeveloped, creating an urgent need for high-speed data transmission networks.</p>
            <br></br>

            <strong>•Localization of Advanced Korean Technology:</strong>
            <p>By establishing a production base in Jashore EPZ, we are introducing world-class Korean fiber optic and optical sensor technology to reduce import dependency and foster self-sufficiency in telecommunications infrastructure.</p>
            <br></br>

            <strong>•Global Export Hub & Market Leadership:</strong>
            <p>Beyond capturing the domestic market, we aim to leverage the strategic and institutional advantages of the Export Processing Zone (EPZ) to expand into South Asian and global markets.</p>
            <br></br>

          </div>
        );

        case 'Products':
              return(
                <div className="sub-content-detail">
                  <h2>PRODUCT & PROCESS</h2><br></br>
                  <div className="video-player-wrapper">
                      <video 
                      src={productmp}
                      controls
                      className="profile-video"
                      />
                      <div className="video-fixed-subtitle4">
                        <p>
                          <span className="sub-line">Driving Innovation through Korea’s</span><br></br>
                          <span className="sub-line">Technological Excellence</span>
                        </p>
                      </div>
                  </div><br></br><br></br>
                  <h2>KEY PRODUCT PORTFOLIO</h2><br></br>
                
                  <h3>Advanced Fiber Optic Cable Line-up</h3><br></br>
                  <p>Essential infrastructure for high-speed, loss-free data transmission.</p>
                  <p>We produce a comprehensive portfolio  ranging from raw fibers to specialized industrial cables.</p>
                  
                  <br></br>
                  <strong>• Core Network Solutions:</strong>
                  <p>Optical Fiber(preform/strand), Distribution Cable, and Central Loose Tube Cable</p>
                  
                  <br></br>
                  <strong>• Last-Mile & Connectivity:</strong>
                  <p>Simplex & Duplex Cable and Breakout Cable for local connections and terminal distribution.</p>

                  <br></br>
                  <strong>• FTTX & Smart City Solutions:</strong>
                  <p>PU Drop Cable, FIG-8 Drop Cable, Square Type Drop Cable, Toneable Flat Drop Cable, and FTTX Distribution Cable — all critical for bringing high-speed internet directly to homes and businesses.</p>
                  <br></br>
                  <p className='bold'> Providing the most stable and cost-effective foundation for nationwide 5G infrastructure, 
 high-speed internet, and smart home networks.</p>
                  <br></br>
                  <br></br>

                  <h3>Optical Water Quality Sensors</h3>
                  <p>Precision instruments that use light properties (refraction and absorption) to monitor water quality in real-time.</p>
                  <br></br>

                  <strong>• Applications:</strong>
                  <p>Smart Water Management and Smart Aquaculture.</p>
                  <br></br>

                  <p className="bold"> Protecting Bangladesh’s abundant water resources and maximizing the productivity of the aquaculture industry through data-driven technology.</p>
                  <br></br>
                  <br></br>

                  <h3>Future-Ready Optical Solutions</h3>
                  <strong>• Optical Spectrometer Solution:</strong>\
                  <p>High-precision analysis of material composition using light wavelengths, contributing to the advancement of local chemical, bio, and pharmaceutical research.</p>
                  <br></br>

                  <strong>• FFR(Flexible Functional Router) System Solution:</strong>
                  <p>Next-generation solutions designed to enhance the flexibility and stability of complex optical networks.</p>
                  <br></br>

                  <div className="sub-content-detail">
                    <h2> Innovative Process  </h2><br></br>
                    <div class="product-image-container">
                      <img src={productImg}></img>
                    </div>
                  </div>
                </div>
              );
          
          case 'Global Market':
                return(
                  <div className="sub-conent-detail">
                    <h2>INTRODUCTION OF WORLD CLASS TECHNOLOGY</h2>
                    <br></br>
                    <p>Direct Local Manufacturing Powered by Korea’s Advanced Technology </p>
                    <p>A leading Technology Innovator MSGOC from Korea</p>
                    <br></br>
                    <div className="profile-worker-big">
                      <div className="profile-worker-row2">
                        <div className="profile-worker-wrapper">
                          <img
                          src={globalimg1}
                          className="profile-work-img"
                          ></img>
                        </div>
                        <div className="profile-worker-wrapper">
                          <img
                          src={globalimg2}
                          className="profile-work-img"
                          ></img>
                        </div>
                      </div>
                      <p>MSGOC’s Headquaters & Plant in Gwangju, Republic of Korea</p>
                    </div><br></br>
                    <br></br>


                    <h2>PRODUCTION CAPACITY  </h2><br></br>
                    <p>Producing world-class advanced optical fiber products through outstanding technological expertise and continuous research and innovation in the world</p>
                    <br></br>
                    <h3>Total Capacity by MSGOC 108,260Km/month</h3>
                    <br></br>

                    <div className="korea-image-container">
                      <img src={koreaImg}/>
                    </div><br></br>
                    <h2>Local Production Plants in a foreign market</h2>
                    <br></br>
                    <p>Established local subsidiaries and currently operating manufacturing plants in Southeast Asia and Central Asia.</p>
                    <div className="local-image-container">
                      <img src={localImg} />
                    </div>
                    <br></br>
                    <br></br>
                      <h2>WORLDWIDE OUR MARKET</h2>
                      <div className="video-player-wrapper">
                        <video 
                        src={globalmp}
                        controls
                        className="profile-video"
                        />
                        <div className="video-fixed-subtitle4">
                          <p>
                            <span className="sub-line">  Providing FTTx Solutions to  </span><br></br>
                            <span className="sub-line">over 20 countries, 30 partners</span>
                          </p>
                      </div>
                      </div><br></br>
                      <br></br>

                      <h3>Providing FTTx Solutions to over 20 countries, 30 partners </h3>

                      <div className="world-image-container">
                        <img src={worldImg} />
                      </div>
                    </div>
                  );

          case 'Benefits':
            return(
              <div className="sub-content-detail">
                <div className="benefit-title">
                  <h2>TRANSFORMATION INTO ADVANCED DIGITAL SOCIETY </h2>
                </div>
                <div className="profile-worker-row">
                  <div className="profile-worker-wrapper">
                    <img
                    src={benefitimg1}
                    className="profile-work-img"
                    ></img>
                  </div>
                  <div className="profile-worker-wrapper">
                    <img
                    src={benefitimg2}
                    className="profile-work-img"
                    ></img>
                  </div>
                </div><br></br>
                <h3>Expected Impact and Value Proposition</h3>
                <br></br>
                <br></br>

                <h3>Telecommunications Paradigm Shift</h3>
                <p>By localizing the production of high-quality cables, we will increase the domestic content rate and significantly reduce the cost of building national infrastructure.</p>
                <br></br>

                <h3>Industrial Innovation in Agriculture & Environment</h3>
                <p>The deployment of optical sensors will lead the transition to "Smart Aquaculture," increasing the value-add of primary industries and supporting climate change resilience.</p>
                <br></br>

                <h3>Economic Vitality and Job Creation</h3>
                <p>The new facility at Jashore EPZ will create high-quality jobs and facilitate the transfer of advanced technical skills to the local workforce.</p>
                <br></br>

                <h3>Boosting Exports and Foreign Exchange</h3>
                <p>Exporting "Made in Bangladesh" high-tech optical products will diversify the nation’s export portfolio and contribute to a favorable trade balance.</p>

              </div>
            );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      {/* 왼쪽 서브 네비게이션 */}
      <aside className="sub-side-nav">
        {['Features', 'Objectives', 'Products', 'Global Market', 'Benefits'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      {/* 오른쪽 상세 내용 */}
      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};

const ContactUs = () => {
  const [subTab, setSubTab] = useState('Contact Us');

  const renderSubContent = () => {
    switch (subTab) {
      case 'Contact Us':
        return(
          <div className="sub-content-detail">
            <div className="video-player-wrapper">
                  <img
                  src={contactimg}
                  className="profile-video"
                  />
                  <div className="video-fixed-subtitle4">
                    <p>
                      <span classname="sub-line">WE ARE READY TO CREATET YOUR VALUE </span>
                      <br></br> 
                      <span classname="sub-line">& FUTURE’S DREAMS TOGETHER.</span>
                      </p>
                  </div>
                  
                </div>
            
            <br></br>
            <br></br>
            <h2>Head Office</h2>
            <br></br>
            <h3>Address</h3>
            <p>167/4  DIT Extention Road, Fakirapul, Motijheel, Dhaka-1000, Bangladesh</p>
            <br></br>
            <p><strong>Phone No:</strong> +88 01912401468 <br></br><br></br>
            <strong>E-mail: </strong>mostafa.romak@gmail.com</p>
          </div>


        );
      default:
        return null;
    }
  };

  return (
    <div className="section horizontal-layout">
      <aside className="sub-side-nav">
        {['Contact Us'].map((item) => (
          <button
            key={item}
            className={`sub-nav-item ${subTab === item ? 'active' : ''}`}
            onClick={() => setSubTab(item)}
          >
            {item}
          </button>
        ))}
      </aside>

      <article className="sub-main-content">
        {renderSubContent()}
      </article>
    </div>
  );
};


export default App;